<template>
    <div>
        <div class="agencyCentre-wrapper teamIncomeOverview-screen" style="background-color: #F2F2F2;">
            <div class="position-relative items-center agencyCentre-headerBar bg-white">
                <div class="angle black-angle" id="close" @click="goToAgencyCenter"></div>
                <div class="text-center agencyCentre-headerHD">Payout History</div>
            </div>
            <div class="py-2">
                <div class="bg-white tradeMain-wrapper trade-transectionHistory">
                    <div class="tradeAcc-statusRight-box d-flex justify-content-between align-items-center px-3">
                        <div class="mt-2 filterType-label">Filter Type :</div>
                        <div class="mt-2 weekdays-dropBox" :style="{ backgroundImage: `url(${down_arrowIcon})` }"
                            @click="openDateModal"> {{ statusFilterLabel }}
                        </div>
                    </div>
                    <div class="py-2 trade-transectionHistory-inner">
                        <!-- Initial page loader -->
                        <div v-if="isInitialLoading" class="page-loader" aria-live="polite">
                            <LoadingOverlay :loading="loading" />
                        </div>
                        <!-- Empty state (after first load) -->
                        <div v-else-if="!loadError && !paymentRequests.length" class="empty-box">
                            No Payout found.
                        </div>
                        <ul class="payoutHistory-listWrapper" v-else>
                            <li class="mb-2 trade-transectionBox" v-for="req in paymentRequests" :key="req.id">
                                <div
                                    class="d-flex justify-content-between align-items-center gap-1 trade-transection-inforBoxes">
                                    <div class="trade-transection-inforleftBox">
                                        <div class="sendTo-title">Account Information :</div>
                                        <div class="d-flex align-items-start trade-userName">
                                            <span class="ac-infoLabel">AC No :</span>
                                            <span class="d-flex align-items-center gap-1 fw-semibold"
                                                @click="onCopy(req.payment_request_account?.account_number)">
                                                {{ req.payment_request_account?.account_number || '-' }}
                                                <img :src='copyIcon' alt="" />
                                            </span>
                                        </div>
                                        <div class="d-flex align-items-start trade-userName">
                                            <span class="ac-infoLabel">IFSC :</span>
                                            <span class="d-flex align-items-center gap-1 fw-semibold"
                                                @click="onCopy(req.payment_request_account?.ifsc_code)">{{
                                                    req.payment_request_account?.ifsc_code || '-' }}
                                                <img :src='copyIcon' alt="" />
                                            </span>
                                        </div>
                                        <div class="d-flex align-items-start trade-userName">
                                            <span class="ac-infoLabel">Name :</span>
                                            <span class="d-flex align-items-center gap-1 fw-semibold"
                                                @click="onCopy(req.payment_request_account?.account_name)">{{
                                                    req.payment_request_account?.account_name || '-' }}
                                                <img :src='copyIcon' alt="" />
                                            </span>
                                        </div>
                                    </div>
                                    <button type="button"
                                        class="d-flex justify-content-center align-items-center gap-1 trade-btn copyAll-btn"
                                        @click="copyAllFromRow(req)">
                                        <img :src='copyIcon' alt="" />
                                        Copy All
                                    </button>
                                    <template v-if="req.screenshot">
                                        <div class="screenshotView-box" @click="showScreenshotPopup(req)">
                                            <img v-bind:src="req.screenshot" alt="" />
                                        </div>
                                    </template>
                                </div>
                                <div
                                    class="d-flex justify-content-between align-items-center gap-2 mt-3 payout-bottomBox payoutBtn-box">
                                    <div :class="[
                                        'd-flex flex-column justify-content-between trade-transection-inforrightBox',
                                        { qrUplod: req.razorpay_status && req.razorpay_status.toLowerCase() === 'processed' }
                                    ]">
                                        <div class="d-flex align-items-center gap-1">
                                            <div class="fw-semibold trade-amount">
                                                <!-- <template v-if="req.total_coins">
                                                    {{ formatNumber(req.total_coins) }}</template>
                                                <template
                                                    v-else-if="req.amount_inr !== null && req.amount_inr !== undefined">
                                                    ₹ {{ formatCurrency(req.amount_inr) }}</template> -->
                                               
                                                <template
                                                    v-if="req.amount_inr !== null && req.amount_inr !== undefined">
                                                    ₹ {{ formatCurrency(req.amount_inr) }}</template>
                                                <template v-else>-</template>
                                            </div>
                                            <!-- <img :src="diamondIcon" class="m-0 diamondIcon" alt="" /> -->
                                        </div>
                                        <div class="bg-white text-center trade-activBtn">
                                            {{ req.razorpay_status ? capitalize(req.razorpay_status) : "Pending" }}
                                        </div>
                                    </div>
                                    <button type="button"
                                        v-if="!(req.razorpay_status && req.razorpay_status.toLowerCase() === 'processed')"
                                        class="trade-btn trade-primary-btn" @click="showRulesPopup(req)">Take
                                        Action</button>
                                </div>
                            </li>
                        </ul>
                        <!-- Infinite scroll sentinel -->
                        <div ref="sentinel" class="py-2 text-center text-muted" v-show="!isInitialLoading">
                            <div v-if="isPageLoading">Loading more…</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Payment Request Popup -->
        <div class="mode-area" v-show="isPopupOverlayVisible"></div>
        <div id="rulesPopup" :class="{
            'bg-white tradeConfirm_popup popup_box': true,
            'rule-pop-up': true,
            'transform-in': requestActionPopupVisible,
            'transform-out': !requestActionPopupVisible
        }">
            <div class="mb-3 text-center fw-semibold rulePopup-topHD">Payment Request Action</div>

            <div>
                <ul class="actionRequestion-listBox" role="radiogroup" aria-labelledby="paymentRequestLabel">
                    <div id="paymentRequestLabel" class="visually-hidden">Payment request status</div>

                    <li>
                        <label for="status_processing" class="d-flex align-items-center gap-1">
                            <input id="status_processing" name="payment_status" type="radio" class="customRadio-btn"
                                value="processing" v-model="selectedStatus" />
                            <span>Processing</span>
                        </label>
                    </li>

                    <li>
                        <label for="status_processed" class="d-flex align-items-center gap-1">
                            <input id="status_processed" name="payment_status" type="radio" class="customRadio-btn"
                                value="processed" v-model="selectedStatus" />
                            <span>Processed</span>
                        </label>

                        <div v-if="selectedStatus === 'processed'" class="processed-formBox" aria-live="polite">
                            <div class="mb-2 trade-formGroup">
                                <label for="utr_input" class="mb-1 trade-label">UTR</label>
                                <input id="utr_input" type="text" inputmode="numeric" class="trade-formControl"
                                    placeholder="Enter UTR" autocomplete="off" aria-describedby="utr_error"
                                    v-model="utr" required />
                                <div id="utr_error" class="text-danger error" v-show="showErrors && !utr">Required</div>
                            </div>

                            <div class="mb-2 trade-formGroup">
                                <label for="screenshot_input" class="mb-1 trade-label">Screenshot File</label>

                                <div class="d-flex align-items-center bg-white overflow-hidden w-100 file-wrapper">
                                    <!-- real input (hidden) -->
                                    <input id="screenshot_input" ref="screenshotInput" type="file"
                                        class="trade-formControl file-input-hidden" aria-describedby="screenshot_error"
                                        @change="onFileChange" required />

                                    <!-- show file name -->
                                    <span class="file-name">{{ fileName || 'Choose file' }}</span>

                                    <!-- label tied to input to trigger file chooser -->
                                    <label for="screenshot_input" class="browse-btn">Browse</label>
                                </div>

                                <div id="screenshot_error" class="text-danger error" v-show="showErrors && !fileName">
                                    Required</div>
                            </div>
                        </div>
                    </li>

                    <li>
                        <label for="status_failed" class="d-flex align-items-center gap-1">
                            <input id="status_failed" name="payment_status" type="radio" class="customRadio-btn"
                                value="failed" v-model="selectedStatus" />
                            <span>Failed</span>
                        </label>
                    </li>

                    <li>
                        <label for="status_pass" class="d-flex align-items-center gap-1">
                            <input id="status_pass" name="payment_status" type="radio" class="customRadio-btn"
                                value="pass" v-model="selectedStatus" />
                            <span>Pass</span>
                        </label>
                    </li>
                </ul>
            </div>

            <div class="d-flex justify-content-center align-items-center gap-2 mt-4 confirm-popupBtn">
                <button type="button" class="trade-btn trade-primary-btn" :disabled="loading || !selectedRequestId"
                    @click="onSave">
                    {{ loading ? 'Processing...' : 'Save' }}
                </button>
                <button type="button" class="trade-btn" @click="onCancel">Cancel</button>
            </div>
            <!-- NEW: server error message -->
            <div v-if="actionError" class="text-center text-danger mb-2 mt-2">
                {{ actionError }}
            </div>
        </div>

        <!-- View Screenshot -->
        <div :class="[
            'screenshot-popup pt-5',
            'bg-white tradeConfirm_popup popup_box rule-pop-up',
            viewScreenshotPopupVisible ? 'transform-in' : 'transform-out'
        ]">
            <div class="screenshot-popupcloseBtn" @click="showScreenshotPopup">
                <img :src='popupCloseIcon' alt="" />
            </div>
            <div class="d-flex justify-content-center screenshot-popupImageBox">
                <img v-bind:src="screenshotImage" alt="screenshotImage" />
            </div>
        </div>

        <!-- Action Filter Select popup -->
        <div class="dateSelectionModal" :style="showModal ? { bottom: '0' } : {}" v-if="showModal" @click="closeModal">
            <div class="dateSelectionModal-body" :style="{ bottom: '0' }" @click.stop>
                <div class="text-center text-white dateSelection-HD" style="background-color: #FF569E;">Filter Type
                </div>
                <ul class="filterOptions-list">
                    <ul class="filterOptions-list">
                        <li v-for="option in actionOptions" :key="option"
                            class="d-flex justify-content-center align-items-center gap-2 filterOptions-box"
                            :class="{ 'active-filterOptions': statusFilter === option.toLowerCase() }"
                            @click="onFilterChange(option.toLowerCase())">
                            <div class="numberOf-week">{{ option }}</div>
                        </li>
                    </ul>

                </ul>
            </div>
        </div>

        <!-- simple copied popup -->
        <div v-if="showCopyPopup" class="copy-popup">Copied: {{ lastCopied }}</div>
    </div>
</template>

<script>
import axios from 'axios';
import './TradeAccount.css';
import diamondIcon from '../../assets/images/diamond-icon.png';
import copyIcon from '../../assets/images/copy_icon.svg';
import popupCloseIcon from '../../assets/images/popupCloseIcon-gray.svg'
import down_arrowIcon from '../../assets/images/down_arrowIcon.png';
import LoadingOverlay from '../LoadingOverlay.vue'

export default {
    name: 'TradeTransectionHistory',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            diamondIcon,
            copyIcon,
            popupCloseIcon,
            down_arrowIcon,
            showCopyPopup: false,
            isPopupOverlayVisible: false,
            requestActionPopupVisible: false,
            showModal: false,
            selectedStatus: '',

            viewScreenshotPopupVisible: false,

            fileName: '',
            selectedFile: null,
            utr: '',
            showErrors: false,
            loading: false,
            actionError: '',
            actionSuccess: '',


            // token
            token: '',
            // API list state
            paymentRequests: [],
            currentPage: 1,
            perPage: 10,
            hasMore: true,
            isInitialLoading: false,
            isPageLoading: false,
            loadError: null,
            totalCount: null,

            // UI filter model + API payload
            statusFilter: '',
            statusFilterLabel: 'All',
            selectedFilter: {
                user_type: '',
                razorpay_status: ''
            },

            // internals
            observer: null,
            busy: false,

            // Which row is being actioned
            selectedRequestId: null,
            screenshotImage: null,
            serverError: '',

            actionOptions: ["All", "Processing", "Processed", "Failed", "Pass"],
        };
    },

    mounted() {
        // this.token = String((this.$route.query.token ?? this.$route.params.token ?? '')).trim()
        // sessionStorage.setItem("tradeAcountToken", this.token)

        this.token = sessionStorage.getItem("tradeAcountToken") || '';
        this.initIntersectionObserver();
        this.fetchFirstPage();
    },

    beforeUnmount() {
        if (this.observer && this.$refs.sentinel) {
            this.observer.unobserve(this.$refs.sentinel);
        }
        this.observer = null;
    },
    methods: {
        onFilterChange(option) {
            const normalized = (String(option || '')).trim().toLowerCase();
            this.statusFilter = (normalized === 'all' || normalized === '') ? '' : normalized;
            if (normalized === 'all' || normalized === '') {
                this.statusFilterLabel = 'All';
            } else {
                this.statusFilterLabel = String(option).charAt(0).toUpperCase() + String(option).slice(1);
            }

            // Map UI to payload
            this.selectedFilter.razorpay_status = this.statusFilter;
            this.paymentRequests = [];
            this.currentPage = 1;
            this.hasMore = true;
            this.loadError = null;
            this.busy = false;

            this.fetchFirstPage();
            this.showModal = false;
        },
        // ---------------- API INTEGRATION ----------------
        async fetchFirstPage() {
            this.loading = true;
            this.isInitialLoading = true;
            this.loadError = null;
            this.paymentRequests = [];
            this.currentPage = 1;
            this.hasMore = true;

            try {
                await this.fetchPage(this.currentPage);
            } catch (err) {
                this.loadError = this.humanizeError(err);
            } finally {
                this.isInitialLoading = false;
                this.loading = false;

            }
        },

        async fetchNextPage() {
            if (!this.hasMore || this.isPageLoading || this.isInitialLoading) return;
            this.isPageLoading = true;
            this.loadError = null;
            try {
                await this.fetchPage(this.currentPage + 1);
            } catch (err) {
                this.loadError = this.humanizeError(err);
            } finally {
                this.isPageLoading = false;
            }
        },

        async fetchPage(page) {
            // Debounce guard
            if (this.busy) return;
            this.busy = true;

            const url = 'api/trader-assigned-payout';

            const payload = {
                user_type: this.selectedFilter.user_type,
                page: String(page),
                razorpay_status: this.selectedFilter.razorpay_status
            };

            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`
            };

            const { data } = await axios.post(url, payload, { headers });

            if (!data?.success) {
                this.busy = false;
                throw new Error('API response unsuccessful');
            }

            this.selectedFilter.user_type = data?.result?.selected;
            this.selectedFilter.razorpay_status = data?.result?.selectedStatus;

            const pg = data?.result?.paymentRequests

            const rows = Array.isArray(pg?.data) ? pg.data : [];

            // Append
            this.paymentRequests = [...this.paymentRequests, ...rows];

            // Keep some meta
            this.currentPage = pg?.current_page ?? page;
            this.perPage = pg?.per_page ?? this.perPage;
            // naive total (if from/to exists)
            if (pg?.to !== undefined && pg?.from !== undefined) {
                this.totalCount = pg?.to; // server sample doesn't include total, so we keep null or last "to"
            }

            // Determine hasMore
            this.hasMore = !!pg?.next_page_url;

            this.busy = false;
        },

        retry() {
            if (this.paymentRequests.length === 0) {
                this.fetchFirstPage();
            } else {
                this.fetchNextPage();
            }
        },

        humanizeError(err) {
            const msg = err?.response?.data?.message || err?.message || 'Something went wrong';
            return `Failed to load data: ${msg}`;
        },

        initIntersectionObserver() {
            const sentinel = this.$refs.sentinel;
            if (!sentinel) return;

            this.observer = new IntersectionObserver(
                (entries) => {
                    const entry = entries[0];
                    if (entry.isIntersecting) {
                        this.fetchNextPage();
                    }
                },
                {
                    root: null,
                    rootMargin: '0px 0px 200px 0px',
                    threshold: 0.01
                }
            );

            this.observer.observe(sentinel);
        },

        // ---------------- Formatting helpers ----------------
        formatNumber(n) {
            try {
                return new Intl.NumberFormat('en-IN').format(Number(n));
            } catch {
                return n;
            }
        },
        formatCurrency(n) {
            try {
                return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n));
            } catch {
                return n;
            }
        },
        formatDate(s) {
            // API sample has mixed formats; just show raw or normalize common patterns
            if (!s) return '-';
            // If already ISO: 2025-09-09T10:06:35.000000Z
            if (/\d{4}-\d{2}-\d{2}T/.test(s)) {
                const d = new Date(s);
                if (!isNaN(d)) return d.toLocaleString('en-IN');
            }
            // If like "09-09-2025 16:22:40" -> DD-MM-YYYY HH:mm:ss
            const m = s.match(/^(\d{2})-(\d{2})-(\d{4}) (\d{2}:\d{2}:\d{2})$/);
            if (m) {
                const [, dd, mm, yyyy, time] = m;
                const iso = `${yyyy}-${mm}-${dd}T${time}`;
                const d = new Date(iso);
                if (!isNaN(d)) return d.toLocaleString('en-IN');
            }
            return s;
        },
        capitalize(s) {
            if (!s) return s;
            return String(s).charAt(0).toUpperCase() + String(s).slice(1);
        },

        // ---------------- Popups ----------------
        showScreenshotPopup(res) {
            this.screenshotImage = res.screenshot
            this.viewScreenshotPopupVisible = !this.viewScreenshotPopupVisible;
            this.isPopupOverlayVisible = !this.isPopupOverlayVisible;
        },

        // ---------- Action Popup ----------
        showRulesPopup(req) {
            // If called with a row, set selectedRequestId
            if (req && req.id) {
                this.selectedRequestId = req.id;
            }

            this.actionError = '';
            this.actionSuccess = '';
            this.showErrors = false;
            this.requestActionPopupVisible = !this.requestActionPopupVisible;
            this.isPopupOverlayVisible = !this.isPopupOverlayVisible;

            if (!this.requestActionPopupVisible) {
                this.resetProcessedForm();
                this.selectedStatus = 'pending';
                this.selectedRequestId = null;
            } else {
                // default to current / processing
                this.selectedStatus = 'pending';
            }
        },

        onFileChange(e) {
            const files = e.target.files;
            if (files && files.length > 0) {
                this.selectedFile = files[0];
                this.fileName = files[0].name;
            } else {
                this.selectedFile = null;
                this.fileName = '';
            }
        },

        openDateModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },

        // ------ APPROVAL ACTION: POST multipart/form-data ------
        async onSave() {
            if (!this.selectedRequestId) {
                this.actionError = 'No payment request selected.';
                return;
            }

            // Validation for "processed"
            this.showErrors = false;
            if (this.selectedStatus === 'processed') {
                if (!this.utr || !this.selectedFile) {
                    this.showErrors = true;
                    return;
                }
            }

            this.loading = true;
            this.actionError = '';
            this.actionSuccess = '';

            try {
                const url = '/api/trader-assigned-payout-action';
                const form = new FormData();
                form.append('paymentrequestid', String(this.selectedRequestId));
                form.append('paymentrequest_status', this.selectedStatus);
                if (this.utr) form.append('utr', this.utr);
                // Only attach screenshot when processed (as per spec)
                if (this.selectedStatus === 'processed' && this.selectedFile) {
                    form.append('screenshot', this.selectedFile, this.selectedFile.name);
                }

                const headers = {
                    'Authorization': `Bearer ${this.token}`
                    // Do NOT set Content-Type; let the browser/axios set multipart boundary
                };

                const { data } = await axios.post(url, form, { headers });

                if (data?.success === false) {
                    throw new Error(data?.message || 'Action failed');
                }

                // Optimistic local update for that row
                // this.updateRowAfterAction(this.selectedRequestId, this.selectedStatus, this.utr);

                this.actionSuccess = 'Action saved successfully.';
                this.fetchFirstPage();
                // small delay so users can see success, then close
                setTimeout(() => {
                    this.loading = false;
                    this.showRulesPopup();
                }, 500);
                return;
            } catch (err) {
                this.actionError = this.humanizeError(err);
            } finally {
                this.loading = false;
            }
        },

        updateRowAfterAction(id, status, utr) {
            const idx = this.paymentRequests.findIndex(r => r.id === id);
            if (idx === -1) return;

            const row = { ...this.paymentRequests[idx] };

            // Prefer razorpay_status for display
            row.razorpay_status = status;

            // If processed, set numeric status as well (guess: 1)
            if (status === 'processed') {
                row.status = 5;
                if (utr) {
                    row.utr_no = utr;
                }
            } else if (status === 'failed') {
                row.status = 2;
            } else if (status === 'processing') {
                row.status = 3;
            } else if (status === 'pending') {
                row.status = 0;
            }

            // Update updated_at to now (optimistic)
            row.updated_at = new Date().toISOString();

            // Replace in list
            this.$set ? this.$set(this.paymentRequests, idx, row) : (this.paymentRequests[idx] = row)
        },

        onCancel() {
            this.showRulesPopup();
        },

        resetProcessedForm() {
            this.fileName = '';
            this.utr = '';
            // clear file input value so it can be reselected later
            if (this.$refs.screenshotInput) {
                this.$refs.screenshotInput.value = '';
            }
        },

        // ---------- Clipboard ----------
        async onCopy(value) {
            if (!value) return;
            this.lastCopied = value;
            await this._copyText(String(value));
        },

        async copyAllFromRow(req) {
            const acc = req.payment_request_account || {};
            const lines = [
                `${acc.account_number || ''}`,
                `${acc.ifsc_code || ''}`,
                `${acc.account_name || ''}`
            ].filter(Boolean);
            const textToCopy = lines.join('\n') || '-';
            this.lastCopied = textToCopy;
            await this._copyText(textToCopy);
        },
        // centralized copy helper using Clipboard API + fallback
        async _copyText(text) {
            const copySuccess = () => {
                this.showCopyPopup = true;
                setTimeout(() => {
                    this.showCopyPopup = false;
                }, 2000);
            };

            if (navigator?.clipboard?.writeText) {
                try {
                    await navigator.clipboard.writeText(text);
                    copySuccess();
                } catch (err) {
                    console.error('Clipboard API failed:', err);
                    this.fallbackCopyText(text, copySuccess);
                }
            } else {
                this.fallbackCopyText(text, copySuccess);
            }
        },

        fallbackCopyText(text, callback) {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                callback?.();
            } catch (err) {
                console.error('Fallback copy failed:', err);
            }
            document.body.removeChild(textarea);
        },
        // ---------- Clipboard ----------

        // viewClose(status) {
        //     if (window.Android && typeof Android.viewClose === "function") {
        //     Android.viewClose(status);
        //     } else {
        //     window.parent.postMessage({ action: "closePopup", status }, "*");
        //     }
        // },

        goToAgencyCenter() {
            this.$router.go(-1);
        },
    }
};
</script>
